import './styles/faq.css'
import AccordionItem from './AccordionItem'

const items = [
    {
        title:'What does the package include?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How does the 14-day trial work?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How do I pay for your service?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'Can I suggest a new feature?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How to restore your chat history?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How does the 14-day trial work?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How do I pay for your service?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'Can I suggest a new feature?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
    {
        title:'How to restore your chat history?',
        body:`
        When you buy Sassio, you get all you see in the demo but the images. We include SASS files for
         styling, complete JS files with comments, all HTML variations. Besides we include all mobile PSD
          mockups.mea case duis tollit et. Etiam nusquam 
        set minium eu sea, ei tale paulo elab. Noluisse mnesarch Et is vero incorrupte eos deserunt quaeren.
        `
    },
]

export default function Faq() {
  return (
    <div className='faq'>
      <div className="container">
        <div className='faq__info'>
            <div className='faq__title'>
                Frequently Asked Questions
            </div>
            <div className='faq__subtitle'>
                Here we could include a little description for this page Andrew.
            </div>
        </div>
      </div>
      <div className='faq__accordion'>
        {items.map((item,index) => {
            return(
                <AccordionItem key={index} item={item}/>
            )
        })}
      </div>
    </div>
  )
}
